import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_small_fallback_paywall~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__b'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_small_fallback_paywall~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__b'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_small_fallback_paywall~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__b'),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_small_fallback_paywall~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__b'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_small_fallback_paywall~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__b'),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_small_fallback_paywall~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__b'),
			},
		},
		// The male tai-chi paywalls ship no discount-on-abort offer at all (every `fallback` ident is
		// null, no `PaywallDiscountOnAbortModal`), so the overlay would never render. `__b_fallback_offer`
		// enables the offer inside the variant — control keeps its current behaviour.
		'activity-male-chair-tai-chi': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_small_fallback_paywall~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__b_fallback_offer'),
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_small_fallback_paywall~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__b_fallback_offer'),
			},
		},
		'activity-male-tai-chi-yoga-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-al&exp=web_small_fallback_paywall~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__b_fallback_offer'),
			},
		},
	},
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_small_fallback_paywall~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__c'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_small_fallback_paywall~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__c'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_small_fallback_paywall~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__c'),
			},
		},
	},
]

export default config
